export default {
  progress: {
    remainingTime: null,
    lastUpdate: null,
    bytesSentSoFar: 0,
    progressBytesSentSoFar: 0,
    bytesPerSecondLog: [],
    duration: 0,
    percentage: 0,
  },
};
